import { Sidebar } from './Sidebar';
import { Outlet } from 'react-router-dom';
import './App.css'

function App() {
  return (
    <div className="flex min-h-screen overflow-hidden">
      <Sidebar variant="default" />

      <main className="flex-1 p-6 ml-64">
        <Outlet/>
      </main>
    </div>
  );
}

export default App
